module.exports = __webpack_public_path__ + "media/images/payments/worldpay-1e1e9b8e20fb277a00c961c7887beeca.svg";